// extracted by mini-css-extract-plugin
export default {"Terms":"Terms_Terms__AYbaE","Legal":"Terms_Legal__wV3bU","TermsOfUse":"Terms_TermsOfUse__bgKHY"};